import { useState } from 'react'
import {
  ImportantMessageInput,
  ModalDialog,
  Mtds,
  templates,
  useCreateImportantMessageMutation,
  SaveError,
  widgets
} from 'prove-common'
import {
  customizeValidator,
  Form,
  IChangeEvent,
  RJSFSchema,
  UiSchema
} from 'prove-common/rjsf'

export const importantMessageSchema: RJSFSchema = {
  type: 'object',
  properties: {
    title: {
      type: 'string',
      title: 'Tittel',
      maxLength: 120,
      description: 'Tittel på meldingen'
    },
    text: {
      type: 'string',
      title: 'Tekst',
      maxLength: 300,
      description: 'Tekst i meldingen'
    },
    startDate: {
      type: 'string',
      format: 'date-time',
      title: 'Start dato',
      description: 'Start dato for meldingen'
    },
    endDate: {
      type: 'string',
      format: 'date-time',
      title: 'Slutt dato',
      description: 'Slutt dato for meldingen'
    }
  },
  required: ['title', 'startDate', 'endDate']
}
export const importantMessageUiSchema: UiSchema<ImportantMessageInput> = {
  'ui:options': {
    allowWrap: true
  },
  title: {
    'ui:widget': 'textarea',
    'ui:placeholder': 'Skriv her...'
  },
  text: {
    'ui:widget': 'textarea',
    'ui:classNames': 'basis-full max-w-initial',
    'ui:placeholder': 'Skriv her...',
    'ui:options': {
      rows: 5
    }
  }
}

type CreateImportantMessageModalProps = {
  isOpen: boolean
  setOpen: (isOpen: boolean) => void
}

export const CreateImportantMessageModal = ({
  isOpen,
  setOpen
}: CreateImportantMessageModalProps) => {
  const createImportantMessage = useCreateImportantMessageMutation()
  const [saveError, setSaveError] = useState<unknown>()
  const onSubmit = ({
    formData
  }: IChangeEvent<ImportantMessageInput>): void => {
    if (formData != null && !createImportantMessage.isPending) {
      setSaveError(undefined)
      createImportantMessage
        .mutateAsync(formData)
        .then(() => {
          Mtds.toast.success('Meldingen er opprettet')
          setOpen(false)
        })
        .catch((error) => {
          setSaveError(error)
        })
    }
  }
  const validator = customizeValidator<ImportantMessageInput>()
  return (
    <ModalDialog
      id='create-important-message-modal'
      closedby='any'
      open={isOpen}
      onClose={() => setOpen(false)}
    >
      <Mtds.Button
        command='close'
        commandfor='create-important-message-modal'
        aria-label={'Lukk'}
      />
      <Mtds.Prose>
        <Mtds.Heading>Ny melding</Mtds.Heading>
        <SaveError error={saveError} action='opprette meldingen' />
        <Form<ImportantMessageInput>
          noHtml5Validate
          schema={importantMessageSchema}
          uiSchema={importantMessageUiSchema}
          widgets={widgets}
          templates={templates}
          showErrorList={false}
          validator={validator}
          onSubmit={onSubmit}
        >
          <Mtds.Flex style={{ paddingTop: 'var(--mtds-8)' }}>
            <Mtds.Button
              command='close'
              commandfor='create-important-message-modal'
            >
              Forkast
            </Mtds.Button>
            <Mtds.Button
              data-variant={'primary'}
              type='submit'
              aria-busy={createImportantMessage.isPending}
              disabled={createImportantMessage.isPending}
            >
              Opprett
            </Mtds.Button>
          </Mtds.Flex>
        </Form>
      </Mtds.Prose>
    </ModalDialog>
  )
}
